import { Boxes } from 'lucide-react';
import { IconSectionHeader } from '@/components/shared/IconSectionHeader';
import { SectionLabel } from '@reflex/ui/components/layout/Typography';

interface BlueprintContributions {
  systemSetupCommands?: string[];
}

export function PluginBlueprintSection({
  contributions,
}: {
  contributions: BlueprintContributions;
}) {
  const commands = contributions.systemSetupCommands ?? [];
  if (commands.length === 0) return null;

  return (
    <section data-testid="plugin-detail-section-blueprint">
      <IconSectionHeader icon={Boxes}>Blueprint Contributions</IconSectionHeader>
      <div>
        <SectionLabel as="span" className="mb-2 block">
          System setup commands
        </SectionLabel>
        <pre className="overflow-x-auto rounded-lg border bg-muted/40 p-3 font-mono text-xs leading-relaxed">
          {commands.join('\n')}
        </pre>
      </div>
    </section>
  );
}
